export default __webpack_public_path__ + "static/media/Voorbeeld_LuFo_Groningen_50cm_2021.a2ff411c.jpg";